<template>
  <div>
    <Nav></Nav>
    <b-container fluid class="mt-3">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h2 class="mb-0">Dashboard ejecutivo</h2>
        <b-button size="sm" variant="outline-secondary" @click="recalc" :disabled="recalculating">
          <b-spinner v-if="recalculating" small></b-spinner>
          Recalcular rango
        </b-button>
      </div>

      <exec-filters v-model="filters" @apply="onApply"></exec-filters>

      <b-tabs v-model="tabIndex" card lazy>
        <b-tab title="Resumen">
          <exec-summary :filters="filters" @go-tab="goTab" @error="toastErr"></exec-summary>
        </b-tab>
        <b-tab title="Ventas">
          <exec-sales :filters="filters" @error="toastErr"></exec-sales>
        </b-tab>
        <b-tab title="Clientes">
          <exec-customers :filters="filters" @error="toastErr"></exec-customers>
        </b-tab>
        <b-tab title="Lealtad">
          <exec-loyalty :filters="filters" @error="toastErr"></exec-loyalty>
        </b-tab>
        <b-tab title="Membresías">
          <exec-tiers :filters="filters" @error="toastErr"></exec-tiers>
        </b-tab>
        <b-tab title="Promociones">
          <exec-promotions :filters="filters" @error="toastErr"></exec-promotions>
        </b-tab>
        <b-tab title="Marketing">
          <exec-marketing :filters="filters" @error="toastErr"></exec-marketing>
        </b-tab>
        <b-tab v-if="flag('whatsapp.channel')" title="WhatsApp">
          <exec-whatsapp :filters="filters"></exec-whatsapp>
        </b-tab>
        <b-tab title="Entregas">
          <exec-delivery :filters="filters" @error="toastErr"></exec-delivery>
        </b-tab>
        <b-tab v-if="flag('events.taquizas')" title="Taquizas">
          <exec-events :filters="filters"></exec-events>
        </b-tab>
        <b-tab title="Referidos">
          <exec-referrals :filters="filters" @error="toastErr"></exec-referrals>
        </b-tab>
        <b-tab v-if="flag('surveys')" title="Satisfacción">
          <exec-voc :filters="filters"></exec-voc>
        </b-tab>
        <b-tab title="Finanzas">
          <exec-finance :filters="filters" @error="toastErr"></exec-finance>
        </b-tab>
        <b-tab title="Alertas">
          <exec-alerts :filters="filters" @error="toastErr"></exec-alerts>
        </b-tab>
      </b-tabs>
    </b-container>
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue';
import axios from 'axios';
import featuresService from '@/services/featuresService';
import ExecFilters from './ExecFilters.vue';
import ExecSummary from './ExecSummary.vue';
import ExecSales from './ExecSales.vue';
import ExecCustomers from './ExecCustomers.vue';
import ExecLoyalty from './ExecLoyalty.vue';
import ExecTiers from './ExecTiers.vue';
import ExecPromotions from './ExecPromotions.vue';
import ExecMarketing from './ExecMarketing.vue';
import ExecWhatsapp from './ExecWhatsapp.vue';
import ExecDelivery from './ExecDelivery.vue';
import ExecEvents from './ExecEvents.vue';
import ExecReferrals from './ExecReferrals.vue';
import ExecVoc from './ExecVoc.vue';
import ExecFinance from './ExecFinance.vue';
import ExecAlerts from './ExecAlerts.vue';

// Dashboard ejecutivo (doc 04 §3, A.15). Las pestañas WhatsApp (8), Taquizas (10) y
// Satisfacción (12) sólo aparecen si su flag está activo; taquizas y satisfacción
// pertenecen a la Fase 5 (diferida) y por eso quedan ocultas por defecto.
export default {
  name: 'ExecDashboard',
  components: {
    Nav, ExecFilters, ExecSummary, ExecSales, ExecCustomers, ExecLoyalty, ExecTiers,
    ExecPromotions, ExecMarketing, ExecWhatsapp, ExecDelivery, ExecEvents,
    ExecReferrals, ExecVoc, ExecFinance, ExecAlerts
  },
  data() {
    return {
      filters: {},
      tabIndex: 0,
      features: {},
      recalculating: false,
      // Mapa de nombre lógico → título de pestaña visible para navegación desde KPIs.
      tabTitles: {
        summary: 'Resumen', sales: 'Ventas', customers: 'Clientes', loyalty: 'Lealtad',
        tiers: 'Membresías', promotions: 'Promociones', marketing: 'Marketing',
        delivery: 'Entregas', referrals: 'Referidos', finance: 'Finanzas', alerts: 'Alertas'
      }
    };
  },
  created() {
    this.loadFeatures();
  },
  methods: {
    flag(key) {
      const f = this.features[key];
      return !!(f && f.enabled);
    },
    loadFeatures() {
      featuresService.getAll()
        .then((res) => { this.features = (res.data && res.data.features) || {}; })
        .catch(() => { this.features = {}; });
    },
    onApply(f) { this.filters = f; },
    goTab(name) {
      const title = this.tabTitles[name];
      if (!title) return;
      // Busca el índice de la pestaña por título en los tabs renderizados (respeta las
      // pestañas ocultas por flag, que no aparecen en el DOM).
      const tabs = this.$el.querySelectorAll('.nav-link');
      tabs.forEach((el, i) => { if (el.textContent.trim() === title) this.tabIndex = i; });
    },
    recalc() {
      this.recalculating = true;
      axios.post('/jobs/analytics_materialize')
        .then(() => this.toast('Recalculado', 'Materialización ejecutada.', 'success'))
        .catch((err) => this.toastErr(err))
        .finally(() => { this.recalculating = false; });
    },
    toast(title, msg, variant) {
      this.$bvToast.toast(msg, { title, variant, autoHideDelay: 4000, appendToast: true });
    },
    toastErr(err) {
      const msg = (err && err.response && err.response.data) || (err && err.message) || 'Error';
      this.toast('Error', typeof msg === 'string' ? msg : JSON.stringify(msg), 'danger');
    }
  }
}
</script>
